module.exports = __webpack_public_path__ + "static/sheela-peryroyl-symbol-DND3_FnP-0a725d141583f45fc11fbee31adce726.webp";